/**
 * View components for explicit routes. Created to minimize typos since the component names are often
 * referenced by String.
 */
export default {
  home: 'Home',
  selectType: 'TypeSelection',
  selectSlot: 'SlotSelection',
  userInfo: 'UserInformation',
  payment: 'Payment',
  confirmRes: 'Confirmation',
  doneRes: 'ReservationFinal',
  findRes: 'Lookup',
  updateRes: 'Modification',
  pageNotFound: 'PageNotFound',
  verifyRes: 'VerifyReservation',
  selectTypeOptions: 'TypeOptions',  // for visit types that require additional sub-options before slot selection
};